export default __webpack_public_path__ + "c837e2f4cfede57c3cc7e1cdbc1e14f0.png";